import { x } from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'

export interface BadgeProps extends HTMLXStyledProps<'span'> {}

export const Badge = forwardRef<BadgeProps, 'span'>((props, ref) => {
  return (
    <x.span
      ref={ref}
      px={1}
      textTransform='uppercase'
      fontSize='xs'
      fontWeight='bold'
      borderRadius='sm'
      display='inline-block'
      whiteSpace='nowrap'
      verticalAlign='middle'
      bg='grey.d1'
      color='white'
      {...props}
    />
  )
})
